import {Component, OnDestroy, OnInit, ViewChild, QueryList, ViewChildren} from '@angular/core';
import {InfluencerGroupsService} from './influencer-groups.service';
import {ReferenceDataService} from '../../services/reference-data/reference-data.service';
import {GroupService} from '../../services/group-details/group.service';
import {UserService} from '../../services/user.service';
import {Platform} from '../../../models/platform';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {CommonConstant, RecentlyVisitedInfluencerGroup, InfluencerGroupStatus} from '../../app.constants';
import {AddInfluencerGroup} from '../../../models/influencer';
import {TranslateService} from '@ngx-translate/core';
import {AbstractAchooComponent} from '../abstract-achoo.component';
import { ActivePages, EventTrackerService, UserActionType, Page, TargetType, ActionSource, ActionDetails } from '../../services/event-tracker/event-tracker.service';
import {InfluencerSuggestion} from '../../../models/influencer-suggestion';
import { ActivePage } from '../../../models/event-tracker';
import {CacheService} from '../../services/cache/cache.service';
import {InvalidAction, User} from '../../../models/user';
import * as Sentry from '@sentry/browser';
import {WebUtils} from '../../utils/web.utils';
import { AppSettings } from '../../utils/app-settings';
import { InfluencerGroup } from '../../../models/influencer-group';
import { ObjectUtils } from '../../utils/object.utils';
import { CreateGroupFragmentComponent } from './create-group-fragment/create-group-fragment.component';
import { GroupItemComponent } from './group-item/group-item.component';
import {Subscription} from 'rxjs/Subscription';
import {ProjectService} from '../../services/project/project.service';
import { Project } from '../../../models/project/project';
import { Country } from '../../../models/country';
import {NewInfluencerGroup} from '../../../models/auto-group/auto-group-setting';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { GroupDetailsComponent } from '../group-details/group-details.component';
import {CampaignService} from '../../services/campaign/campaign.service';
import {FormControl} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'influencer-groups',
  templateUrl: './influencer-groups.component.html',
  styleUrls: ['./influencer-groups.component.scss']
})
export class InfluencerGroupsComponent extends AbstractAchooComponent implements OnInit, OnDestroy {
  @ViewChild('WarningDeleteInfluencerGroupDialog')
  warningDeleteInfluencerGroupDialog: AchooPopupComponent;
  @ViewChild('AlertAddInfluencerToGroupSuccess')
  alertAddInfluencerToGroupSuccess: AchooPopupComponent;
  @ViewChild('NotificationDeleteGroup')
  notificationDeleteGroup: AchooPopupComponent;
  @ViewChild('AlertRecentlyVisitedInfluencerApiFail')
  alertRecentlyVisitedInfluencerApiFail: AchooPopupComponent;
  private _alertRecentlyVisitedInfluencerApiFailRef: any;
  @ViewChild('AddInfluencerToGroupErrorPopup')
  public addInfluencerToGroupErrorPopup: AchooPopupComponent;
  @ViewChild('NewGroupSettingErrors')
  public newGroupSettingErrors: AchooPopupComponent;
  @ViewChild('createGroupFragment')
  public createGroupFragment: CreateGroupFragmentComponent;
  @ViewChildren(GroupItemComponent) groupItemList: QueryList<GroupItemComponent>;
  @ViewChild('CreateNewGroupError')
  public createNewGroupError: AchooPopupComponent;
  @ViewChild('GroupDetailComponent')
  public groupDetailComponent: GroupDetailsComponent;

  public influencerGroupList: any = [];
  // Keep previous influencer group and used in case update failed.
  public previousInfluencerGroupList: any = [];
  public groupConditionTypes: any = [];
  public isShowCreateGroupForm: boolean | false;
  public isShowAddInfluencerToGroup: boolean | false;
  public isShowAddInfluencerManuallyFragment: boolean | false;
  // show/hide edit project fragment
  public isShowEditProjectFragment: boolean | false;
  public selectedInfluencerGroup: any | null;
  // search box
  public searchTerm = '';
  public searchTermControl = new FormControl();
  private searchTermCtrlSub: Subscription;
  public platformList: Platform[] = [];
  public deleteGroupName: string | null;

  public listProjectOfAdvertiser: any  = [];

  // keep the previous selected influencers
  public selectedInfluencerToAddGroup: InfluencerSuggestion[];
  // keep the index of selected influencer to add manually
  public indexInfluencerManually: number;
  public processingInfluencerSuggestion: InfluencerSuggestion;
  // delete group notification popup data
  public deletePopupTitle: string;
  public deletePopupMsg: string;
  public isFetchingGroups = false;
  public isLoadingRecentlyVisitedInfluencerList = false;
  public hasNoGroup = false;
  public isRequestReview = false;
  public hasPendingInfluencer = false;
  public pendingAddInfluencerToGroup: AddInfluencerGroup;
  public groupNeedToUpdate: InfluencerGroup;

  // This is used for temporary hidden create new group fragment
  public temporaryHidden = false;
  // create/update project subscription
  public processingProject;
  private createOrUpdateProjectSubscription: Subscription;

  public isShowEditProject: boolean | false;
  public selectedProject: Project = new Project();
  private previousSelectedProject: Project = new Project();
  public countryList: Array<Country> = [];
  public newGroupSettingErrorMsg: string;

  // Variable use for intermediate group details page
  public newCreatedInfluencerGroup: InfluencerGroup = new InfluencerGroup();
  public showIntermediateGrouDetail = false;
  public isHiddenBottomBar = false;

  // This is used for temporary hidden add influencer to group fragment
  public temporaryHiddenAddInfluencerToGroup = false;
  private searchingGroupSubscription: Subscription;

  private _destroyed$: Subject<boolean> = new Subject();

  constructor(private influencerGroupsService: InfluencerGroupsService,
              private referenceDataService: ReferenceDataService,
              protected userService: UserService,
              private groupService: GroupService,
              private placeholderService: PlaceholderVisibilityService,
              private modalService: ModalService,
              private eventTracker: EventTrackerService,
              private cacheService: CacheService,
              private projectService: ProjectService,
              private translate: TranslateService,
              private router: Router,
              private campaignService: CampaignService,
              private location: Location) {
      super(userService);
   }

  ngOnInit() {
    super.ngOnInit();
    this.platformList = this.referenceDataService.platforms;
    this.isRequestReview = AppSettings.isRequestReview();
    this.createOrUpdateProjectSubscription = this.projectService.createOrUpdateProjectObserver.subscribe((project) => {
      if (project) {
        this.processingProject = project;
        this.isShowEditProjectFragment = true;
      }
    });
    this.countryList = this.referenceDataService.countries.map((country) => ({
        id: country.id,
        name: country.name
      })
    );
    // debounce keystroke events
    this.searchTermCtrlSub = this.searchTermControl.valueChanges
      .debounceTime(500)
      .subscribe(newValue => {
        if (this.searchingGroupSubscription) {
          this.searchingGroupSubscription.unsubscribe();
        }
        this.searchGroup(newValue);
      });
  }

  ngOnDestroy() {
    this._destroyed$.next(true);
    super.ngOnDestroy();
    if (this.createOrUpdateProjectSubscription) {
      this.createOrUpdateProjectSubscription.unsubscribe();
    }
    this.modalService.closeSinglePopup(this._alertRecentlyVisitedInfluencerApiFailRef);
  }

  initInfluenceGroupList(companyId, reloadGroupList?: boolean) {
    if (reloadGroupList) {
      this.cacheService.clear(`influencer_group_list_${companyId}`);
    }
    this.loadInfluencerGroup(companyId);

    this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_SOURCE_KEY, this.groupService.getInfluencerGroupSourceTypes()).subscribe();
    this.cacheService.get(CommonConstant.NEW_AUTO_GROUP_FILTER_KEY, this.groupService.getInfluencerGroupFilterTypes()).subscribe();
    // load and cache the branded signup
    this.userService.getSignUpPageData(companyId).subscribe((res) => {
      this.cacheService.set(`${CommonConstant.BRANDED_SIGNUP_CONFIG_KEY}_${companyId}`, res);
    }, (err) => {
      if (err.status === 404) {
        this.cacheService.set(`${CommonConstant.BRANDED_SIGNUP_CONFIG_KEY}_${companyId}`, null);
      }
    });
    this.cacheService.get(`campaign_list_${companyId}`, this.campaignService.getCampaignShortListForCompany(companyId)).subscribe();
    this.cacheService.get(`group_list_${companyId}`, this.influencerGroupsService.getInfluencerGroupShortList(companyId)).subscribe();
    this.getAllProjectOfAdvertiser(false);
  }

  private getAllProjectOfAdvertiser(isUpdatingAutoGroup: boolean) {
    this.cacheService.get(CommonConstant.LIST_PROJECT_KEY, this.userService.getAllProjectOfAdvertiser())
    .subscribe((res: any) => {
      if (!res || !res.data) {
        this.listProjectOfAdvertiser = [];
      }
      if (isUpdatingAutoGroup) {
        const currentProjectList = this.listProjectOfAdvertiser.map(p => p.id);
        const selectedProject = this.selectedProject.id > 0 ? this.selectedProject : res.data.find(p => currentProjectList.indexOf(p.id) < 0);
        const groupItem: GroupItemComponent = this.groupItemList.find(gi => gi.showGroupSetting === true);
        if (groupItem && groupItem.newGroupSetting && selectedProject) {
          groupItem.newGroupSetting.updateSelectedProjectForSource(selectedProject);
        }
      }
      this.listProjectOfAdvertiser = res.data;
    });
  }

  companyChangeCallback(companyId) {
    this.initInfluenceGroupList(companyId);
  }

  private loadInfluencerGroup(companyId, influencerGroupId?) {
    console.log('load all groups');
    this.isFetchingGroups = true;
    if (!this.cacheService.has(`influencer_group_list_${companyId}`)) {
      this.placeholderService.show(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
    }
    this.addRecentlyVisitedInfluencerGroup(companyId);
    this.cacheService.get(`influencer_group_list_${companyId}`,
      this.influencerGroupsService.getInfluencerGroups(companyId).pipe(takeUntil(this._destroyed$))).subscribe( (data) => {
      this.isFetchingGroups = false;
      let groupData = [];
      if (Array.isArray(data)) {
        groupData = this.normalizedGroupData(data);
        console.log(`update UI all groups ${groupData.length}`);
        if (influencerGroupId) {
          const groupNeedToUpdate = this.influencerGroupList.findIndex(ig => ig.id === influencerGroupId);
          const updatedGroup = groupData.find(ig => ig.id === influencerGroupId);
          this.influencerGroupList[groupNeedToUpdate].influencers = updatedGroup.influencers;
        } else {
          this.influencerGroupList = groupData;
        }
        const filteredList = this.influencerGroupList.filter(item => item.totalPendingInfluencers > 0);
        this.hasPendingInfluencer = filteredList && filteredList.length > 0 ? true : false;
      }
      this.placeholderService.hide(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
      // Below if condition is for case creating new group.
      if (this.previousInfluencerGroupList && this.previousInfluencerGroupList.length > 0 && this.influencerGroupList.length > this.previousInfluencerGroupList.length) {
        this.getNewCreatedGroup();
      }
    }, (err) => {
      this.isFetchingGroups = false;
      this._alertRecentlyVisitedInfluencerApiFailRef = this.modalService.openInCenter(this.alertRecentlyVisitedInfluencerApiFail, undefined);
      this.placeholderService.hide(CommonConstant.INFLUENCER_GROUP_LIST_HOLDER);
    });
  }

  private normalizedGroupData(data) {
    const groups = data;
    groups.forEach((grp) => {
      grp.totalFollowers = grp.groupKpi ? grp.groupKpi.totalFollowers : 0;
      grp.totalEngagement = grp.groupKpi ? grp.groupKpi.totalEngagement : 0;
      grp.totalImpression = grp.groupKpi ? grp.groupKpi.totalImpression : 0;
      grp.totalReach = grp.groupKpi ? grp.groupKpi.totalReach : 0;
      grp.totalPendingInfluencers = grp.totalPendingInfluencers ? grp.totalPendingInfluencers : 0;
    });
    const monthlyVisitedGroup = this.influencerGroupList.filter(ig => ig.id === 0);
    return groups.concat(...monthlyVisitedGroup);
  }

  afterCreateGroup() {
    this.isShowCreateGroupForm = false;
    this.isShowAddInfluencerToGroup = false;
    this.initInfluenceGroupList(this.companyId, true);
  }

  onAddInfluencerGroup(influencerGroup) {
    this.selectedInfluencerGroup =  influencerGroup;
    this.selectedInfluencerGroup.influencer_group_id = influencerGroup.id;
    this.selectedInfluencerGroup.influencer_group_name = influencerGroup.name;
    this.isShowCreateGroupForm = false;
    this.isShowAddInfluencerToGroup = true;
    this.temporaryHidden = false;
  }

  closeAddInfluencerToGroup(data) {
    if (!data.isTemporaryHidden) {
      this.temporaryHiddenAddInfluencerToGroup = false;
      this.isShowCreateGroupForm = false;
      this.isShowAddInfluencerToGroup = false;
      if (data.resetSelectedInfluencer) {
        // clear cached influencer selection
        this.selectedInfluencerToAddGroup = [];
        // clear the pending influencer to add to group
        this.pendingAddInfluencerToGroup = null;
      }
      if (data.bulkUploadInfluencers && data.bulkUploadInfluencers.length > 0) {
        this.cacheService.clear(`influencer_group_list_${this.companyId}`);
        this.loadInfluencerGroup(this.companyId, data.influencerGroupId);
      }
    } else {
      this.temporaryHiddenAddInfluencerToGroup = true;
    }

  }

  addMoreInfluencerToCurrentGroup(data) {
    this.pendingAddInfluencerToGroup = data.addInfluencerGroup;
    this.selectedInfluencerToAddGroup = data.selectedInfluencers;
    this.addInfluencerToGroup(data.addInfluencerGroup);
  }

  private addInfluencerToGroup(influencerToAdd: AddInfluencerGroup) {
    if (influencerToAdd.influencerList.length === 0) {
      return;
    }
    if (influencerToAdd.addForReview) {
      this.addInfluencerToGroupAsPending(influencerToAdd);
    } else {
      this.addInfluencerToGroupAsNormal(influencerToAdd);
    }
  }

  private addInfluencerToGroupAsNormal(influencerToAdd: AddInfluencerGroup) {
    this.groupService.addInfluencerToGroup(influencerToAdd).subscribe((res: any) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd, false);
      this.eventTracker.trackUserAction(UserActionType.CHAM_ADD_INFLUENCER_TO_GROUP);
    }, error => {
      this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
    });
  }

  private addInfluencerToGroupAsPending(influencerToAdd: AddInfluencerGroup) {
    this.groupService.addInfluencerToGroupAsPending(influencerToAdd).subscribe((res) => {
      this.afterAddingInfluencerToGroupSuccess(influencerToAdd, true);
    }, err => {
      this.isShowAddInfluencerToGroup = true;
      this.modalService.openInCenter(this.addInfluencerToGroupErrorPopup);
    });
  }

  private afterAddingInfluencerToGroupSuccess(influencerToAdd: AddInfluencerGroup, addForReview: boolean) {
    this.modalService.open(this.alertAddInfluencerToGroupSuccess, undefined, true);
    this.closeAddInfluencerToGroup({
      resetSelectedInfluencer: true
    });
    this.initInfluenceGroupList(this.companyId, true);
    // track event to Segment
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
      id: influencerToAdd.influencer_group_id,
      name: influencerToAdd.influencerGroupName,
      type: TargetType.INFLUENCER_GROUP
    }, {
      action: UserActionType.UPDATE,
      source: ActionSource.ACTION_VIEW,
      actionDetails: addForReview ? ActionDetails.ADDED_INFLUENCERS_FOR_REVIEW : ActionDetails.ADDED_INFLUENCERS,
      ...influencerToAdd
    }, undefined, {
      type: ActivePages.GROUP_OVERVIEW,
    });
  }

  private sendInvalidActionToSegement(limitInfo, influencerAddToGroup) {
    const detailAction = new InvalidAction(true, limitInfo.blockedReason, limitInfo.wallType, limitInfo.wallName, true,
      limitInfo.maxValue, limitInfo.desiredValue, this.userService.accountLevelName);
    // send event when adding influencer to group
    if (influencerAddToGroup) {
      this.eventTracker.trackUserInvalidAction(detailAction, UserActionType.ACTION, Page.GROUP, {
        id: influencerAddToGroup.influencer_group_id,
        name: influencerAddToGroup.influencerGroupName,
        type: TargetType.INFLUENCER_GROUP
      }, {
        action: UserActionType.UPDATE,
        source: ActionSource.ACTION_VIEW,
        actionDetails: ActionDetails.ADDED_INFLUENCERS,
        ...influencerAddToGroup
      }, undefined, {
        type: ActivePages.GROUP_OVERVIEW,
      });
    }
  }

  showWarningDeleteInfluencerGroupPopup(influencerGroup) {
    this.deleteGroupName =  influencerGroup.name;
    this.selectedInfluencerGroup = influencerGroup;
    this.modalService.openInCenter(this.warningDeleteInfluencerGroupDialog);
  }
  closeWarningDeleteInfluencerGroupPopup() {
    this.selectedInfluencerGroup = null;
    this.modalService.close();
  }

  deleteInfluencerGroup() {
    if (this.selectedInfluencerGroup) {
      // optimis UI, close popup, remove group in UI immediately
      this.modalService.close();
      const deleteGroupIndex = this.influencerGroupList.findIndex(ig => ig.id === this.selectedInfluencerGroup.id);
      this.influencerGroupList.splice(deleteGroupIndex, 1);
      this.influencerGroupsService.deleteInfluencerGroup(this.selectedInfluencerGroup.id).subscribe( (data) => {
        // build success popup data
        this.deletePopupTitle = this.translate.instant('notification.success');
        this.deletePopupMsg = this.translate.instant('group_details.influencer.delete_group_success');
        this.modalService.open(this.notificationDeleteGroup, this.callbackAfterCloseDeleteGroupNotification.bind(this), true);
        // track event to Segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.GROUP, {
          id: this.selectedInfluencerGroup.id,
          name: this.selectedInfluencerGroup.name,
          type: TargetType.INFLUENCER_GROUP
        }, {
          action: UserActionType.DELETE,
          source: ActionSource.PAGE,
          ...this.selectedInfluencerGroup
        }, undefined, {
          type: ActivePages.GROUP_OVERVIEW,
        });
      }, (err) => {
        // show notification when error happen
        this.deletePopupTitle = this.translate.instant('notification.error');
        this.deletePopupMsg = this.translate.instant('group_details.influencer.delete_group_error');
        this.modalService.open(this.notificationDeleteGroup, this.callbackAfterCloseDeleteGroupNotification.bind(this), true);
        // revert group in case API fail
        this.influencerGroupList.splice(deleteGroupIndex, 1, this.selectedInfluencerGroup);
      });
    }
  }

  callbackAfterCloseDeleteGroupNotification() {
    this.deletePopupTitle = null;
    this.deletePopupMsg = null;
  }

  showCreateGroupForm(evt?) {
    const influencerGroup = new InfluencerGroup();
    if (evt) {
      influencerGroup.influencer_group_id = evt.id;
      influencerGroup.influencer_group_name = evt.name;
      influencerGroup.influencer_group_description = evt.description;
      influencerGroup.influencer_group_type = evt.type;
    }
    this.groupNeedToUpdate = evt ? influencerGroup : null;
    this.isShowCreateGroupForm = true;
    this.temporaryHidden = false;
    this.isShowAddInfluencerToGroup = false;
    this.temporaryHiddenAddInfluencerToGroup = false;
  }

  cancelCreateOrUpdateGroup() {
    this.isShowCreateGroupForm = false;
    this.isShowAddInfluencerToGroup = false;
  }

  get isOpenBottomBar() {
    return this.isShowCreateGroupForm === true || this.isShowAddInfluencerToGroup === true
      || this.isShowAddInfluencerManuallyFragment || this.isShowEditProject === true;
  }

  get isCloseBottomBar() {
    return this.isShowCreateGroupForm === false && this.isShowAddInfluencerToGroup === false
      && this.isShowAddInfluencerManuallyFragment === false && !this.isShowEditProject;
  }

  get isOpenAddInfluencerManually() {
    return this.isShowAddInfluencerManuallyFragment === true;
  }

  showFragmentAddInfluencerManually(evt) {
    this.selectedInfluencerToAddGroup = evt.selectedInfluencers;
    this.indexInfluencerManually  = evt.processingIndex;
    this.processingInfluencerSuggestion = evt.influencerSuggestion;
    this.isShowAddInfluencerManuallyFragment = true;
    this.isShowAddInfluencerToGroup = false;
    this.pendingAddInfluencerToGroup = evt.pendingAddInfluencerToGroup;
  }

  closeFragmentAddInfluencerManually(influencer?: InfluencerSuggestion) {
    if (influencer) {
      this.selectedInfluencerToAddGroup.splice(this.indexInfluencerManually, 1, influencer);
    }
    this.processingInfluencerSuggestion = null;
    this.indexInfluencerManually = null;
    this.isShowAddInfluencerToGroup = true;
    this.isShowAddInfluencerManuallyFragment = false;
  }

  closeEditProjectFragment() {
    this.isShowEditProjectFragment = false;
  }

  get showCreateGroupButton() {
    return !this.isShowCreateGroupForm && !this.isShowAddInfluencerToGroup
      && !this.isShowAddInfluencerManuallyFragment && !this.isShowEditProject;
  }

  get activePage(): ActivePage {
    return {
      type: ActivePages.GROUP_OVERVIEW
    };
  }

  get invalidActionData() {
    return {
      action: UserActionType.ACTION,
      item: Page.GROUP,
      target: {
        type: TargetType.INFLUENCER_GROUP
      },
      params: {
        action: UserActionType.CREATE,
      },
      activePage: {
        type: ActivePages.GROUP_OVERVIEW,
      }
    };
  }

  private addRecentlyVisitedInfluencerGroup(companyId) {
    this.isLoadingRecentlyVisitedInfluencerList = true;
    const recentlyVisitedGroup = {
      id: 0,
      name: RecentlyVisitedInfluencerGroup.name,
      description: RecentlyVisitedInfluencerGroup.description,
      influencers: [],
      totalInfluencers: 0
    };
    const addedGroup = this.influencerGroupList.filter(item => item.name === RecentlyVisitedInfluencerGroup.name);
    if (addedGroup.length === 0) {
      this.influencerGroupList.push(recentlyVisitedGroup);
    }
    this.groupService.getMonthlyVisitInfluencer(companyId, 8, 0)
      .pipe(takeUntil(this._destroyed$)).subscribe(
        (res) => {
          this.isLoadingRecentlyVisitedInfluencerList = false;
          this.influencerGroupList.map(groupItem => {
            if (groupItem.name === RecentlyVisitedInfluencerGroup.name) {
              groupItem.influencers = res.influencers;
              groupItem.totalInfluencers = res.total;
            }
          });
        }, (err) => {
        WebUtils.reportErrorToSentry('Failed to load Recently Viewed influencers', err);
        this.modalService.openInCenter(this.alertRecentlyVisitedInfluencerApiFail, undefined);
      });
  }

  closeErrorMsgModal() {
    this.modalService.close();
  }

  beforeCreateOrUpdateGroup(evt) {
    if (!evt) {
      return;
    }
    this.temporaryHidden = true;
    this.previousInfluencerGroupList = ObjectUtils.deepClone(this.influencerGroupList);
    if (evt && !evt.isCreated) {
      // process case update
      this.beforeUpdateGroupEvent(evt);
    } else {
      // process case create
      this.beforeCreateGroupEvent(evt);
    }
  }

  private beforeUpdateGroupEvent(evt) {
    this.influencerGroupList = this.influencerGroupList.map(item => {
      if (item.id === evt.influencerGroupId) {
        item.name = evt.influencerGroupName;
        item.description = evt.influencerGroupDescription;
      }
      return item;
    });
    this.groupItemList.map(item => {
      if (item.influencerGroup.id === evt.influencerGroupId) {
        item.isUpdatingGroupInfo = true;
      }
    });
  }

  private beforeCreateGroupEvent(evt) {
    this.newCreatedInfluencerGroup.influencer_group_id = CommonConstant.NEW_CREATED_GROUP_ID;
    this.newCreatedInfluencerGroup.influencer_group_name = evt.data.name;
    this.newCreatedInfluencerGroup.influencer_group_description = evt.data.description;
    this.newCreatedInfluencerGroup.status = InfluencerGroupStatus.PENDING;
    this.showIntermediateGrouDetail = true;
  }

  afterCreateOrUpdateGroup(evt) {
    if (evt && !evt.isCreated) {
      this.afterUpdateGroupEvent(evt);
    } else {
      this.afterCreateGroupEvent(evt);
    }
  }

  private afterUpdateGroupEvent(evt) {
    this.groupItemList.map(item => {
      if (item.influencerGroup.id === evt.data.influencerGroupId) {
        item.isUpdatingGroupInfo = false;
      }
    });
    if (!evt.isError) {
      this.temporaryHidden = true;
      this.isShowCreateGroupForm = false;
      this.groupItemList.map(item => {
        if (item.influencerGroup.id === evt.data.influencerGroupId) {
          // Re-assign new value to influencerGroup for create-group-fragment after updating success
          this.groupNeedToUpdate.influencer_group_name = evt.data.influencerGroupName;
          this.groupNeedToUpdate.influencer_group_description = evt.data.influencerGroupDescription;
          // update cached data in group item
          item.updateNewValueForCachedData(evt.data.influencerGroupId, this.groupNeedToUpdate);
        }
      });
      this.sendUpdateGroupNameEvent(evt.data);
    } else {
      this.temporaryHidden = false;
      this.influencerGroupList = this.previousInfluencerGroupList;
      this.newGroupSettingErrorMsg = this.translate.instant('new_group_settings.update_group_name_error');
      this.modalService.open(this.newGroupSettingErrors, null, true);
    }
  }

  private afterCreateGroupEvent(evt) {
    if (!evt.isError) {
      this.temporaryHidden = true;
      this.isHiddenBottomBar = true;
      this.afterCreateGroup();
    } else {
      this.modalService.open(this.createNewGroupError, null, true);
      this.temporaryHidden = false;
      this.showIntermediateGrouDetail = false;
      this.isShowCreateGroupForm = true;
      this.isHiddenBottomBar = false;
    }
  }

  private sendUpdateGroupNameEvent(influencerGroupData) {
    this.eventTracker.trackUserAction(UserActionType.ACTION, Page.INFLUENCER_GROUP, {
      id: influencerGroupData.influencerGroupId,
      name: influencerGroupData.influencerGroupName,
      type: Page.INFLUENCER_GROUP
    }, {
      actionDetails: ActionDetails.UPDATED_DETAILS,
      source: ActionSource.ACTION_VIEW,
      action: UserActionType.UPDATE,
      ...influencerGroupData
    }, undefined, null, null);
  }

  editOrCreateProject(project) {
    this.selectedProject = project;
    this.previousSelectedProject = ObjectUtils.deepClone(project);
    this.isShowEditProject = true;
  }

  closeEditProject(evt) {
    if (evt.isError) {
      this.selectedProject = this.previousSelectedProject;
      this.temporaryHidden = false;
      this.newGroupSettingErrorMsg = evt.isCreated ? this.translate.instant('new_group_settings.create_project_error') : this.translate.instant('new_group_settings.update_project_error');
      this.modalService.open(this.newGroupSettingErrors, null, true);
    } else {
      this.isShowEditProject = false;
      this.temporaryHidden = false;
      this.selectedProject.id = evt.projectId;
      this.cacheService.clear(CommonConstant.LIST_PROJECT_KEY);
      this.getAllProjectOfAdvertiser(true);
    }
  }

  beforeCreateOrUpdateProject() {
    this.temporaryHidden = true;
  }

  searchGroup(term) {
    if (!term || term === '') {
      this.loadInfluencerGroup(this.companyId);
    } else {
      this.isFetchingGroups = true;
      console.log('clear group list');
      this.influencerGroupList = this.influencerGroupList.filter(ig => ig.id === 0);
      this.searchingGroupSubscription = this.influencerGroupsService.searchGroupByTerm(this.companyId, term).subscribe((res) => {
        this.isFetchingGroups = false;
        if (Array.isArray(res)) {
          this.influencerGroupList = this.normalizedGroupData(res);
          console.log(`update UI for matched groups ${this.influencerGroupList.length}`);
        }
      });
    }
  }

  closeTooltip(tc) {
    if (tc) {
      tc.close();
    }
  }

  private getNewCreatedGroup() {
    const newCreatedGroupItems = this.influencerGroupList.filter(listItem => this.previousInfluencerGroupList.every(groupItem => groupItem.id !== listItem.id));
    if (newCreatedGroupItems && newCreatedGroupItems.length > 0) {
      this.groupDetailComponent.influencerGroup.influencer_group_id = newCreatedGroupItems[0].id;
      this.groupDetailComponent.influencerGroup.status = InfluencerGroupStatus.COMPLETE;
      this.groupDetailComponent.influencerGroupId = newCreatedGroupItems[0].id;
      this.groupDetailComponent.ngOnInit();
      this.updateGroupPageUrl(newCreatedGroupItems[0]);
    }
  }

  private updateGroupPageUrl(newCreatedGroupItem) {
    const url = this.router.createUrlTree(['groups', newCreatedGroupItem.id], { queryParams: {activeAccount: this.userService.getCompanyId()} }).toString();
    this.location.go(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/influencer-groups.component.ts